/*
 * Copyright 2016-present Evernote Corporation. All rights reserved.
 *
 * ENConfig
 *
 * Config options that should be checked in to version control.
 *
 */

/* eslint max-len: 0 */
const config = {
  DEV_SERVER_PORT: 3000,
  PUBLIC_PATH: '/ion',
  RTE_WS_SERVER: 'https://rte.www.yinxiang.com',
  RTE_HTTP_SERVER: 'https://rte.www.yinxiang.com',
  EVERNOTE_BUSINESS_ID: 4,
  TASKS_FIRESTORE_API_KEY: '', //TS error fix
  TASKS_FIRESTORE_NAMESPACE: '', //TS error fix
  TASKS_FIRESTORE_PROJECT_ID: '', //TS error fix
  baseUrl: process.env.BASE_URL,
  corpBaseUrl: process.env.CORP_BASE_URL,
  staticBaseUrl: process.env.STATIC_BASE_URL,
  Countly: {
    name: 'Countly',
    appName: 'WebClient',
    server: 'https://analytics.yinxiang.com'
  },
  DASHBOARD: {
    isDebugEnabled: true
  },
  SERVICE_IDENTIFYING_HEADER: {
    NAME: 'En-Client',
    VALUE: process.env.SERVICE_ID || 'ion'
  },
  ION_VERSION_HEADER_NAME: 'Ion-Version',
  FEATURE_VERSION_HEADER: {
    NAME: 'X-Feature-Version',
    VALUE: '3'
  },
  ZENDESK: {
    enableFeedbackCollector: true
  },
  EXPERIMENTS: {
    cacheDurationMinutes: 5,
    backupDurationMinutes: 2880
  },
  // any change to SCHEMA_VERSION must be accompanied by a corresponding
  // upgrade function in evernote-cupboard/migration.js.
  SCHEMA_VERSION: 'ION_9071',
  TASKS: {
    // Shows/hides features that shouldn't be available in Beta but already implemented (see ION-7391)
    showPostBetaFeature: false
  }
};

module.exports = config;
